module.exports = "https://www.gc-pro.gnp.com.mx/a55c0011586041f1bf059352f6b501a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_cellphone.png
// module id = 980
// module chunks = 0